import React, { useEffect, useCallback, useState} from 'react';
import {SAMPLER, INSTRUMENT} from 'constants/track-types.js';
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';

const colors = new Colors();

const MultiFreezeThumbnails = ({track}) => { 
    if (track.frozenTracks === undefined) {
        return [];
    }
    // given
    let thumbnails = [];
    for (let frozen of track.frozenTracks) {
        let {trackData} = frozen;
        if (!trackData) {
            continue;
        }
        let {type, samplers} = trackData;
        let id = "white";
        if (type === SAMPLER) {
            id = Object.keys(samplers)[0];
        } else if (type === INSTRUMENT) {
            id = trackData.presetName || "instrument";
        }
        const color = colors.getColorForHash(id);

        thumbnails.push(
            <div
              style={{backgroundColor: color}}
              className="multi-freeze-part"></div>
        );
    }
    return (
        <div className="multi-freeze-thumbnails">
          {thumbnails}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiFreezeThumbnails);
